import { Svg } from '@ohif/ui';
import React from 'react';

const Inicio = () => {

  const style = {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "black"
  };

  const logoStyle = {
    width: "350px",
    height: "auto",
    marginBottom: "30px"
  }

  const subtituloStyle = {
    color: "#000"
  }
  return (
    <div className='bg-white h-screen flex flex-col'
      style={style}
    >
      <a href="https://med-it.app" target='_blank'>
        <Svg name="logo-pacs" style={logoStyle} />
      </a>
      <a href="https://itestudio.com.ar" target='_blank'>
        <p style={subtituloStyle}>Dessarrollado por <strong>IT Estudio</strong></p>
      </a>
    </div>
  );
}

export default Inicio;